export const CONTACT_INFO = {
  email: "bekzod@me.com",
  phone: "+998 20 002 77 00",
  phoneRaw: "+998200027700",
  address: "Tashkent, Uzbekistan",
} as const;

export const CONTACT_LINKS = {
  email: `mailto:${CONTACT_INFO.email}`,
  phone: `tel:${CONTACT_INFO.phoneRaw}`,
} as const;
